// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".liked-users-sample[data-v-169cbed0]{display:inline-block;background-repeat:no-repeat;background-size:cover;border-radius:50%;margin:2px;width:40px;height:40px}\n", ""]);
// Exports
module.exports = exports;
